export enum StorageKeys {
  PAYMENT = "payment",
  PAYMENT_ID = "payment_id",
}
